module.exports = __webpack_public_path__ + "img/sad_panda3.c5292f15.gif";